export const links = {
	galleryUrl: 'https://whitecrust-clients-storage.nyc3.digitaloceanspaces.com',
	// AUTH ENDPOINTS
	login: 'auth/login',
	loginVerify: 'auth/verifyLogin',
	forgotPassword: 'auth/forget',
	resetPassword: 'auth/reset',
	createAccount: 'admin/administrators/store',
	createToken: 'auth/generate_token',
	checkToken: 'auth/check',
	verifyToken: 'auth/verify',
	checkInvites: 'admin/invite/verify',
	// UTILITIES ENDPOINTS
	listBanks: 'list_banks',
	validateBanks: 'validate_account',
	listBranches: 'list_branches',
	listStates: 'list_states',
	listProducts: 'list_products',
	listUsers: 'list_users',
	// DASHBOARD ENDPOINTS
	executiveDashboard: 'executive_dashboard',
	dashboard: 'dashboard',
	profile: 'profile',
	markAllNotifications: 'mark_all_notifications',
	showNotifications: 'show_notification',
	logout: 'logout',
	sendSms: 'send_sms',
	sendSmsFile: 'send_sms_file',
	// ADMIN ENDPOINTS
	changeAdminStatus: 'change_admin_status',
	admins: 'administrators',
	// AGENT ENDPOINTS
	agents: 'agents',
	agentApproval: 'agents/approval',
	changeAgentStatus: 'change_agent_status',
	updateAgentBranch: 'agents/update-branch',
	// CUSTOMERS ENDPOINTS
	customers: 'customers',
	updateCustomer: 'customers/update',
	// LOANS ENDPOINTS
	loanPreview: 'loans/preview',
	processLoan: 'loans/process-loan',
	disburseLoan: 'loans/disburse',
	returnLoan: 'loans/return',
	loans: 'loanss',
	uploadLoanFile: 'loan-file/upload',
	deleteUploadedLoanFile: 'loan-file/delete',
	markAspaid: 'loans/markpaid',
	moveToActive: 'loans/move-loan',
	// OFFERS ENDPOINTS
	offers: 'offers',
	previewOffer: 'offers/preview',
	// NOTIFICATIONS ENDPOINTS
	notifications: 'notifications',
	// ROLES
	roles: 'roles',
	roleSimple: 'list-roles-simple',
	permissions: 'list-permissions',
	// INVITES ENDPOINTS
	listInvites: 'invite/links',
	createInvites: 'invite/create',
	// REPORT ENDPOINTS
	loanReport: 'reports/loan_report',
	customerReport: 'reports/customer_report',
	offerReport: 'reports/offer_report',
	products: 'products',
	branches: 'branches',
	// Salaries
	salaries: 'salaries',
};
